import { connect } from 'react-redux'
import _ from "lodash";
import ContactShareView from './ContactShareView.jsx';
import { fetchShareForContact } from 'src/legacy/redux/actions/rolodex.jsx';
import { fetchPreviewAsset } from 'src/legacy/redux/actions/assets.jsx';

const mapStateToProps = (state,ownProps) => {
  var id = ownProps.id;

  var shares = state.legacyRootReducer.rolodex.contact.shares.items || [];
  var share = shares.find(item => item.id == id);
  
  return {
    share: share,
    user: _.get(state,"users.me")
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchShareForContact: (id, share) => {
      return dispatch(fetchShareForContact(id, share));
    },

    fetchPreviewAsset: (assetID) => {
      return dispatch(fetchPreviewAsset(assetID));
    }
  }
}

const ContactShareContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactShareView)

export default ContactShareContainer;